import { ResourceProps } from "@refinedev/core";
import { MobileOutlined } from "@ant-design/icons";

export const appIconResource: ResourceProps = {
  name: "app-icon",
  meta: {
    icon: <MobileOutlined />,
    label: "Иконка приложения",
  },
  list: "/app-icon",
};
